import type { CSSProperties, FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface RollTextProps {
    text: string
    className?: string
}

/**
 * Letters that roll up one by one on hover. The hovered ancestor needs the "roll-host" class.
 */
const RollText: FC<RollTextProps> = ({ text, className }): ReactNode => {
    return (
        <span className={cn('roll', className)}>
            <span className='sr-only'>
                {text}
            </span>

            <span aria-hidden='true' className='inline-flex'>
                {Array.from(text).map((char, index) => (
                    <span
                        key={index}
                        data-char={char}
                        className='roll-char'
                        style={{ '--i': index } as CSSProperties}
                    >
                        {char}
                    </span>
                ))}
            </span>
        </span>
    )
}

export default RollText
